import esCoCommon from "./catalogs/es-CO/common.json";
import esCoAutomotive from "./catalogs/es-CO/automotive.json";
import esCoClientView from "./catalogs/es-CO/clientView.json";
import esCoForms from "./catalogs/es-CO/forms.json";
import esCoValidation from "./catalogs/es-CO/validation.json";
import esCoPreferences from "./catalogs/es-CO/preferences.json";
import esCoRealEstate from "./catalogs/es-CO/realEstate.json";
import esCoStudio from "./catalogs/es-CO/studio.json";
import enUsCommon from "./catalogs/en-US/common.json";
import enUsAutomotive from "./catalogs/en-US/automotive.json";
import enUsBuyerChecklist from "./catalogs/en-US/buyerChecklist.json";
import enUsDealerPortalCatalog from "./dealerPortalCatalog/en-US.js";
import esCoDealerPortalCatalog from "./dealerPortalCatalog/es-CO.js";
import enUsClientView from "./catalogs/en-US/clientView.json";
import enUsForms from "./catalogs/en-US/forms.json";
import enUsValidation from "./catalogs/en-US/validation.json";
import enUsPreferences from "./catalogs/en-US/preferences.json";
import enUsRealEstate from "./catalogs/en-US/realEstate.json";
import enUsStudio from "./catalogs/en-US/studio.json";
import esMxCommon from "./catalogs/es-MX/common.json";
import esMxForms from "./catalogs/es-MX/forms.json";
import esMxValidation from "./catalogs/es-MX/validation.json";
import ptBrCommon from "./catalogs/pt-BR/common.json";
import ptBrForms from "./catalogs/pt-BR/forms.json";
import ptBrValidation from "./catalogs/pt-BR/validation.json";
import frFrCommon from "./catalogs/fr-FR/common.json";
import frFrForms from "./catalogs/fr-FR/forms.json";
import frFrValidation from "./catalogs/fr-FR/validation.json";
import ruRuCommon from "./catalogs/ru-RU/common.json";
import ruRuAutomotive from "./catalogs/ru-RU/automotive.json";
import ruRuForms from "./catalogs/ru-RU/forms.json";
import ruRuValidation from "./catalogs/ru-RU/validation.json";
import ruRuPreferences from "./catalogs/ru-RU/preferences.json";
import ruRuClientView from "./catalogs/ru-RU/clientView.json";
import ruRuRealEstate from "./catalogs/ru-RU/realEstate.json";
import ruRuStudio from "./catalogs/ru-RU/studio.json";
import { createTranslationAdapter } from "./translationAdapter.js";
import { FALLBACK_LOCALE } from "./localeResolution.js";

function mergeDealerPortalCatalog(automotive, dealerPortalExtension) {
  return {
    ...automotive,
    dealerPortal: {
      ...(automotive.dealerPortal || {}),
      ...dealerPortalExtension,
    },
  };
}

/** Starter catalogs (M8+) — incomplete locales merge with es-CO fallback per namespace. */
export const CATALOGS = {
  "es-CO": {
    common: esCoCommon,
    automotive: mergeDealerPortalCatalog(esCoAutomotive, esCoDealerPortalCatalog),
    clientView: esCoClientView,
    forms: esCoForms,
    validation: esCoValidation,
    preferences: esCoPreferences,
    realEstate: esCoRealEstate,
    studio: esCoStudio,
  },
  "en-US": {
    common: enUsCommon,
    automotive: mergeDealerPortalCatalog(
      { ...enUsAutomotive, buyerChecklist: enUsBuyerChecklist },
      enUsDealerPortalCatalog
    ),
    clientView: enUsClientView,
    forms: enUsForms,
    validation: enUsValidation,
    preferences: enUsPreferences,
    realEstate: enUsRealEstate,
    studio: enUsStudio,
  },
  "es-MX": {
    common: esMxCommon,
    forms: esMxForms,
    validation: esMxValidation,
  },
  "pt-BR": {
    common: ptBrCommon,
    forms: ptBrForms,
    validation: ptBrValidation,
  },
  "fr-FR": {
    common: frFrCommon,
    forms: frFrForms,
    validation: frFrValidation,
  },
  "ru-RU": {
    common: ruRuCommon,
    automotive: ruRuAutomotive,
    clientView: ruRuClientView,
    forms: ruRuForms,
    validation: ruRuValidation,
    preferences: ruRuPreferences,
    realEstate: ruRuRealEstate,
    studio: ruRuStudio,
  },
};

function mergeCatalogNamespaces(primary = {}, fallback = {}) {
  const merged = { ...fallback };
  for (const [namespace, values] of Object.entries(primary)) {
    merged[namespace] = { ...(fallback[namespace] || {}), ...values };
  }
  return merged;
}

export function buildCatalog(locale) {
  const fallback = CATALOGS[FALLBACK_LOCALE];
  const primary = CATALOGS[locale];
  if (!primary || locale === FALLBACK_LOCALE) {
    return primary || fallback;
  }
  return mergeCatalogNamespaces(primary, fallback);
}

export function createCatalogTranslator(locale, catalogOverride = null) {
  const catalog = catalogOverride || buildCatalog(locale);
  const fallbackCatalog = buildCatalog(FALLBACK_LOCALE);
  return createTranslationAdapter({ catalog, fallbackCatalog, locale });
}

/** @deprecated use createCatalogTranslator — kept for tests */
export function translateFromCatalogs(catalog, fallbackCatalog, key, params = {}, locale = FALLBACK_LOCALE) {
  const adapter = createTranslationAdapter({ catalog, fallbackCatalog, locale });
  return adapter.t(key, params);
}

export function mergeCatalogs(baseCatalog, namespacePatch) {
  return mergeCatalogNamespaces(namespacePatch, baseCatalog);
}
